import {magicItemCollection} from '@/constants/magicItemList'

const genMagicItemLink = (magicItemId) => `[${magicItemCollection[magicItemId].name}](MAGIC_ITEM:${magicItemId})`

export default genMagicItemLink
